import { Link } from 'react-router-dom';
import '../styles/landing.css';

export function NotFoundPage() {
  return (
    <div className="landing" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', textAlign: 'center', padding: '40px' }}>
      <h1 style={{ fontSize: '120px', fontWeight: 800, lineHeight: 1, background: 'var(--ds-gradient-brand-text)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>404</h1>
      <p style={{ fontSize: '20px', color: '#94a3b8', marginBottom: '32px' }}>This page doesn't exist</p>
      <Link to="/" className="landing-btn landing-btn--primary landing-btn--lg">Back to home</Link>
    </div>
  );
}
